// extracted by mini-css-extract-plugin
module.exports = {"grid":"src-InvoicePage-___InvoicePage-module__grid___21y-C"};